import { render, staticRenderFns } from "./fact_alerts.vue?vue&type=template&id=1eee37b6&scoped=true&"
import script from "./fact_alerts.vue?vue&type=script&lang=ts&"
export * from "./fact_alerts.vue?vue&type=script&lang=ts&"
import style0 from "./fact_alerts.vue?vue&type=style&index=0&id=1eee37b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eee37b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VAlert,VDivider})
